import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Tier } from '@/types';

interface TierState {
  tiers: Tier[];
}

const initialState: TierState = { tiers: [] };

const tierSlice = createSlice({
  name: 'tier',
  initialState,
  reducers: {
    setTiers(state, action: PayloadAction<Tier[]>) {
      state.tiers = action.payload;
    },
    addTier(state, action: PayloadAction<Tier>) {
      state.tiers.push(action.payload);
    },
    removeTier(state, action: PayloadAction<number | Tier>) {
      const id = typeof action.payload === 'number' ? action.payload : action.payload.id;
      state.tiers = state.tiers.filter((t) => t.id !== id);
    },
    editTier(state, action: PayloadAction<Tier>) {
      const i = state.tiers.findIndex((t) => t.id === action.payload.id);
      if (i !== -1) state.tiers[i] = action.payload;
    },
  },
});

export const { setTiers, addTier, removeTier, editTier } = tierSlice.actions;
export default tierSlice.reducer;
